import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexRow } from 'styles/layouts';

export const Wrapper = styled(FlexRow)<{ isLink?: boolean }>`
  position: fixed;
  top: 0;
  height: var(--banner-height);
  width: 100%;
  background-color: ${themeStyle.highlight};
  z-index: ${themeStyle.zIndexS9};
  cursor: ${({ isLink }) => (isLink ? 'pointer' : 'default')};
`;

export const Text = styled.div`
  font-weight: ${themeStyle.fontMedium};
  line-height: 19px;
  text-align: center;
  padding: 0 30px;

  color: ${themeStyle.inkBase};
  font-size: ${themeStyle.fontSize12};

  ${QUERIES.tabletAndUp} {
    font-size: ${themeStyle.fontSize14};
  }

  a {
    text-decoration: underline;
  }
`;

export const Close = styled.div`
  position: absolute;
  right: 10px;
  display: inline-flex;
`;
